import { Input } from "antd";
import React from "react";

type CustomColorPickerFieldProps = {
  value?: string;
  onChange?: (color: string) => void;
  inputText?: boolean;
};

export default function CustomColorPickerField({
  value,
  onChange,
  inputText = true,
}: CustomColorPickerFieldProps) {
  const handleColorInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newColor = e.target.value;
    if (onChange) {
      onChange(newColor);
    }
  };

  return (
    <div className="d-flex">
      {inputText ? (
        <Input
          value={value}
          onChange={handleColorInputChange}
          className="m-r-sm"
        />
      ) : null}
      <input
        style={{ width: "2em" }}
        type="color"
        value={value}
        onChange={handleColorInputChange}
      />
    </div>
  );
}
